import styles from "./Chip.module.css";
import { IconWithLabel, Link } from "../Actions";
import { ReactElement } from "react";
import { StaticImageData } from "next/legacy/image";
import NextImage from "next/legacy/image";

type ChipProps = {
  title: string;
  color?: "blue" | "orange" | "teal";
  link: { text: string; to?: string };
  image: StaticImageData;
  align?: "center";
  videoSrc?: string;
  premintHero?: boolean;
};
export const Chip: React.FC<ChipProps> = ({
  title,
  link,
  color = "blue",
  videoSrc
}) => {
  const textColor = {
    blue: "text-coinage-blue",
    orange: "text-coinage-orange",
    teal: "text-coinage-blue"
  };
  const borderColor = {
    blue: "border-coinage-blue",
    orange: "border-coinage-orange",
    teal: "border-coinage-teal"
  };
  return (
    <div
      className={`flex gap-5 rounded-3xl w-full p-2 tab:p-4 mb-2 bg-coinage-offWhite border-[1px] ${
        textColor[color] + " " + borderColor[color]
      }`}>
      <video
        className="rounded-xl object-cover w-[100px] aspect-square "
        autoPlay
        loop
        muted
        playsInline
        controls={false}>
        <source src={videoSrc} type="video/mp4" />
      </video>

      <div className={`flex flex-col justify-center gap-2 text-left`}>
        <h3 className={`subhead2 text-coinage-black`}>{title}</h3>
        <Link
          modifier="tertiary"
          analyticsProperty={"Chip"}
          href={link.to}
          isWrapped
          className={`${textColor[color]} w-full arrow-button text-left`}>
          <IconWithLabel textClassName="text-left" icon="arrow" label={link.text} />
        </Link>
      </div>
    </div>
  );
};
